import { ArticleMagazineModel } from 'src/graphql/generated-types';

const stateName = '[Shared][Magazine] ';

export class SharedMagazineSetMagazineAction {
    static readonly type = stateName + 'SetMagazine';

    constructor(public magazine: ArticleMagazineModel = null) {
    }
}
